<template>
  <LayoutCreate>
    <gdlFormDSL
      :fields="fields"
      :action="actionCreateResource"
      @cancel="onCancel"
    />
  </LayoutCreate>
</template>

<script>
import { keyBy } from 'lodash';
import pageComponent from '@/mixins/page-component';

import http from '@/http';

import gdlFormDSL from '@/components/gdl/FormDSL.vue';
import LayoutCreate from './layouts/LayoutCreate.vue';

export default {
  name: 'RestResourcesIndexCreatePage',
  components: { LayoutCreate, gdlFormDSL },
  mixins: [pageComponent],
  inject: ['config'],
  data() {
    const { fields } = this.config.form;
    return {
      fields,
    };
  },
  computed: {
    namespace() { return `${this.config.store.namespace}/Index`; },
    fieldsBy() { return keyBy(this.fields, 'name'); },
  },
  methods: {
    async createResource({ data }) {
      return this.$store.dispatch(`${this.namespace}/createResource`, { data });
    },
    async actionCreateResource({ data }) {
      try {
        await this.createResource({ data });
        this.afterCreateResource();
        return false;
      } catch (error) {
        if (http.isUnprocessableEntity(error)) {
          const { errors } = error.response.data;
          return errors;
        }
        throw error;
      }
    },
    afterCreateResource() {
      const { name } = this.config.route;
      this.$router.replace({ name });
    },
    onCancel() {
      const { name } = this.config.route;
      this.$router.replace({ name: `${name}` });
    },
  },
};
</script>
